;(() => {
  if (window.__STC_SEARCH_V6__) return;
  window.__STC_SEARCH_V6__ = true;

  const OVERLAY_ID = 'stc-search-overlay';
  const STYLE_ID   = 'stc-search-overlay-style';
  const INPUT_ID   = 'stc-search-input';
  const RESULTS_ID = 'stc-search-results';
  const SUGGEST_URL = '/search/suggest.json';

  let suppressClickUntil = 0;
  let debounceT = null;
  let aborter = null;

  const $  = (s, r=document) => r.querySelector(s);

  function injectStyle(){
    if (document.getElementById(STYLE_ID)) return;
    const s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = `
#${OVERLAY_ID}{
  position:fixed !important; inset:0 !important; display:none !important;
  align-items:center !important; justify-content:center !important;
  padding:14px !important;
  background:rgba(0,0,0,.55) !important;
  backdrop-filter:blur(2px) !important;
  -webkit-backdrop-filter:blur(2px) !important;
  z-index:2147483647 !important;
}
#${OVERLAY_ID}.is-open{display:flex !important;}
#${OVERLAY_ID} .stc-card{
  width:min(560px, 100%) !important;
  background:#fff !important; color:#111 !important;
  border-radius:14px !important;
  box-shadow:0 20px 60px rgba(0,0,0,.35) !important;
  overflow:hidden !important;
}
#${OVERLAY_ID} .stc-top{
  display:flex !important; align-items:center !important; gap:12px !important;
  padding:14px 14px 10px !important;
  border-bottom:1px solid rgba(0,0,0,.08) !important;
}
#${OVERLAY_ID} .stc-title{font-weight:900 !important;font-size:14px !important;letter-spacing:.6px !important;flex:1 !important;}
#${OVERLAY_ID} .stc-close{
  border:0 !important; background:transparent !important; cursor:pointer !important;
  font-size:26px !important; line-height:1 !important; padding:4px 10px !important; opacity:.85 !important;
}
#${OVERLAY_ID} .stc-close:hover{opacity:1 !important;}
#${OVERLAY_ID} form{padding:14px !important;}
#${OVERLAY_ID} input[type="search"]{
  width:100% !important; height:48px !important; border-radius:10px !important;
  border:1px solid rgba(0,0,0,.22) !important;
  padding:0 14px !important; font-size:16px !important; outline:none !important;
}
#${OVERLAY_ID} input[type="search"]:focus{border-color:rgba(0,0,0,.55) !important;}
#${OVERLAY_ID} .stc-actions{display:flex !important; gap:10px !important; margin-top:12px !important;}
#${OVERLAY_ID} .stc-btn{
  height:44px !important; border-radius:10px !important; padding:0 14px !important;
  border:0 !important; cursor:pointer !important; font-weight:900 !important;
}
#${OVERLAY_ID} .stc-primary{
  background:linear-gradient(135deg,#d9004c 0%,#111 100%) !important;
  color:#fff !important; flex:1 !important;
}
#${OVERLAY_ID} .stc-secondary{background:rgba(0,0,0,.06) !important;color:#111 !important;}

#${OVERLAY_ID} .stc-results{
  margin-top:10px !important;
  border:1px solid rgba(0,0,0,.10) !important;
  border-radius:12px !important;
  overflow:hidden !important;
  max-height:min(44vh,340px) !important;
  display:none !important;
}
#${OVERLAY_ID} .stc-results.is-show{display:block !important;}
#${OVERLAY_ID} .stc-item{
  display:flex !important; align-items:center !important; gap:10px !important;
  padding:10px 12px !important;
  text-decoration:none !important;
  color:#111 !important;
  background:#fff !important;
  border-bottom:1px solid rgba(0,0,0,.06) !important;
}
#${OVERLAY_ID} .stc-item:last-child{border-bottom:0 !important;}
#${OVERLAY_ID} .stc-item:hover{background:rgba(0,0,0,.03) !important;}
#${OVERLAY_ID} .stc-thumb{
  width:44px !important; height:44px !important;
  border-radius:10px !important; object-fit:cover !important;
  background:rgba(0,0,0,.06) !important; flex:0 0 auto !important;
}
#${OVERLAY_ID} .stc-meta{min-width:0 !important;}
#${OVERLAY_ID} .stc-name{
  font-weight:800 !important; font-size:14px !important;
  white-space:nowrap !important; overflow:hidden !important; text-overflow:ellipsis !important;
}
#${OVERLAY_ID} .stc-sub{
  font-size:12px !important; opacity:.75 !important;
  white-space:nowrap !important; overflow:hidden !important; text-overflow:ellipsis !important;
}
#${OVERLAY_ID} .stc-footerlink{
  display:block !important;
  padding:10px 12px !important;
  text-decoration:none !important;
  font-weight:900 !important;
  color:#111 !important;
  background:rgba(0,0,0,.03) !important;
}
`;
    document.head.appendChild(s);
  }

  function lockScroll(){
    document.documentElement.dataset.stcScrollLock = '1';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll(){
    if (document.documentElement.dataset.stcScrollLock === '1') {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      delete document.documentElement.dataset.stcScrollLock;
    }
  }

  function ensure(){
    if (document.getElementById(OVERLAY_ID)) return;
    injectStyle();

    const o = document.createElement('div');
    o.id = OVERLAY_ID;
    o.innerHTML = `
<div class="stc-card" role="dialog" aria-modal="true" aria-label="Buscar">
  <div class="stc-top">
    <div class="stc-title">NEZENDGROUP.COM</div>
    <button type="button" class="stc-close" aria-label="Cerrar">×</button>
  </div>
  <form action="/search" method="get" role="search" autocomplete="off">
    <input id="${INPUT_ID}" name="q" type="search" placeholder="Busca productos..." autocomplete="off" spellcheck="false">
    <div id="${RESULTS_ID}" class="stc-results" aria-live="polite"></div>
    <div class="stc-actions">
      <button class="stc-btn stc-primary" type="submit">Buscar</button>
      <button class="stc-btn stc-secondary" type="button" data-stc-close>Cancelar</button>
    </div>
  </form>
</div>`;

    o.addEventListener('click', (e) => {
      if (e.target === o) close();
      if (e.target.closest('.stc-close,[data-stc-close]')) close();
    });

    document.body.appendChild(o);

    // listeners de predicción
    const input = document.getElementById(INPUT_ID);
    if (input) {
      input.addEventListener('input', () => {
        const q = (input.value || '').trim();
        if (debounceT) clearTimeout(debounceT);
        debounceT = setTimeout(() => runSuggest(q), 140);
      });
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { e.preventDefault(); close(); }
      });
    }
  }

  function open(){
    ensure();
    const o = document.getElementById(OVERLAY_ID);
    o.classList.add('is-open');
    lockScroll();
    setTimeout(() => {
      const input = document.getElementById(INPUT_ID);
      if (input) input.focus({ preventScroll:true });
    }, 0);
  }

  function close(){
    const o = document.getElementById(OVERLAY_ID);
    if (!o) return;
    o.classList.remove('is-open');
    unlockScroll();
  }

  function inHeader(el){
    return !!el.closest('header, .shopify-section-header, .header-wrapper, .section-header, #shopify-section-header, .menu-drawer, .drawer');
  }

  function hrefIsSearch(href){
    if (!href) return false;
    try{
      const u = new URL(href, location.origin);
      return u.pathname.replace(/\/+$/,'') === '/search';
    }catch(_){
      return href === '/search' || href.startsWith('/search?');
    }
  }

  function isTrigger(target){
    const el = target.closest('a,button,summary,[role="button"]');
    if (!el) return false;
    if (!inHeader(el)) return false;

    const aria = ((el.getAttribute('aria-label')||'')+' '+(el.getAttribute('title')||'')).toLowerCase();
    const cls  = (el.className||'').toLowerCase();
    const controls = (el.getAttribute('aria-controls')||'').toLowerCase();
    const id = (el.id||'').toLowerCase();

    const a = el.closest('a');
    const href = (el.getAttribute('href')||'') || (a ? (a.getAttribute('href')||'') : '');

    if (hrefIsSearch(href)) return true;
    if (aria.includes('buscar') || aria.includes('search')) return true;
    if (controls.includes('search')) return true;
    if (id.includes('search')) return true;
    if (cls.includes('search')) return true;

    return false;
  }

  function intercept(e){
    // mata el click siguiente (para que NO redirija en PC)
    if (e.type === 'click' && Date.now() < suppressClickUntil) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      return;
    }

    if (e.defaultPrevented) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (typeof e.button === 'number' && e.button !== 0) return;

    if (!isTrigger(e.target)) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    // abre con pointerdown para que quede estático (sin “dejar apretado” en móvil)
    suppressClickUntil = Date.now() + 650;
    open();
  }

  function normalizeImg(src){
    if (!src) return '';
    if (typeof src === 'string') {
      if (src.startsWith('//')) return 'https:' + src;
      return src;
    }
    // por si viene como objeto
    if (src.url) {
      if (src.url.startsWith('//')) return 'https:' + src.url;
      return src.url;
    }
    return '';
  }

  function clearResults(){
    const box = document.getElementById(RESULTS_ID);
    if (!box) return;
    box.innerHTML = '';
    box.classList.remove('is-show');
  }

  async function runSuggest(q){
    const box = document.getElementById(RESULTS_ID);
    if (!box) return;

    if (!q || q.length < 2) { clearResults(); return; }

    // abort previo
    try { aborter?.abort?.(); } catch(_) {}
    aborter = new AbortController();

    const url =
      `${SUGGEST_URL}?q=${encodeURIComponent(q)}` +
      `&resources[type]=product,collection,query` +
      `&resources[limit]=6` +
      `&resources[options][unavailable_products]=hide`;

    let data = null;
    try{
      const res = await fetch(url, {
        signal: aborter.signal,
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      });
      if (!res.ok) throw new Error('suggest not ok');
      data = await res.json();
    }catch(err){
      // si canceló o falló, ocultamos silencioso
      return;
    }

    const results = data?.resources?.results || {};
    const products = Array.isArray(results.products) ? results.products : [];
    const queries  = Array.isArray(results.queries) ? results.queries : [];

    box.innerHTML = '';

    let count = 0;

    // productos
    products.slice(0, 6).forEach(p => {
      const a = document.createElement('a');
      a.className = 'stc-item';
      a.href = p?.url || ('/search?q=' + encodeURIComponent(q));

      const img = document.createElement('img');
      img.className = 'stc-thumb';
      img.loading = 'lazy';
      img.alt = '';
      const src = normalizeImg(p?.image || p?.featured_image || p?.featured_image?.url);
      if (src) img.src = src;
      else img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

      const meta = document.createElement('div');
      meta.className = 'stc-meta';

      const name = document.createElement('div');
      name.className = 'stc-name';
      name.textContent = (p?.title || 'Producto');

      const sub = document.createElement('div');
      sub.className = 'stc-sub';
      sub.textContent = (p?.vendor || p?.product_type || '').toString();

      meta.appendChild(name);
      if (sub.textContent) meta.appendChild(sub);

      a.appendChild(img);
      a.appendChild(meta);

      box.appendChild(a);
      count++;
    });

    // queries sugeridas (si no hay productos)
    if (count === 0 && queries.length) {
      queries.slice(0, 6).forEach(qo => {
        const a = document.createElement('a');
        a.className = 'stc-item';
        a.href = (qo?.url) ? qo.url : ('/search?q=' + encodeURIComponent(qo?.text || q));
        const meta = document.createElement('div');
        meta.className = 'stc-meta';
        const name = document.createElement('div');
        name.className = 'stc-name';
        name.textContent = (qo?.text || q);
        meta.appendChild(name);
        a.appendChild(meta);
        box.appendChild(a);
        count++;
      });
    }

    // footer: ver todos
    const all = document.createElement('a');
    all.className = 'stc-footerlink';
    all.href = '/search?q=' + encodeURIComponent(q);
    all.textContent = `Ver resultados para “${q}”`;
    box.appendChild(all);

    box.classList.add('is-show');
  }

  window.addEventListener('pointerdown', intercept, true);
  window.addEventListener('click', intercept, true);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); }, true);
})();
